import styled, { css } from 'styled-components';
import { VideoRenderer } from 'core';

export const ScreenShareContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
`;

export const ScreenShareVideoRenderer = styled(VideoRenderer)`
    width: 100%;
`;

export const ScreenAuthorDescription = styled.div<{ $isMe: boolean; $hidden?: boolean }>`
    background: ${({ theme, $isMe }) =>
        $isMe ? theme.root.colors.primary.default : theme.root.colors.basicColors.black['80%']};
    border-radius: 8px 8px 0 0;
    padding: 8px 24px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    text-wrap: balance;

    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;

    ${({ $hidden }) =>
        !$hidden &&
        css`
            ${ScreenShareContainer}:hover & {
                opacity: 1;
                pointer-events: auto;
            }
        `}
`;

export const VideoOverlay = styled.div<{ $isMyScreen: boolean }>`
    position: absolute;
    height: 100%;
    width: 100%;

    ${({ $isMyScreen, theme }) => {
        return $isMyScreen ? `background: ${theme.root.colors.basicColors.black['50%']}` : null;
    }}
`;
